const prepareResult = (listOfItems, nestingLevel) => {
  const prefix = nestingLevel ? `${nestingLevel}.` : '';

  return listOfItems.reduce((result, item, index) => {
    const order = `${prefix}${index + 1}`;
    result.push({
      ...item,
      order,
      items: [],
    });

    if (item.items?.length) {
      result.push(...prepareResult(item.items, order));
    }

    return result;
  }, []);
};

export default prepareResult;
